import { useInventory } from "consignment-stock/hooks";
import React from "react";
import LoadingText from "../../layout/components/LoadingText";
import ScanAndFilter from "consignment-stock/components/ScanAndFilter";
import Bottom from "./Bottom";
import Inventory from "./Inventory";
import { useScrollTop } from "layout/hooks/scroll";

const ConsignmentStockMain: React.FC = () => {
  useScrollTop();
  // Fetch inventory data with no cache to ensure updated data
  const { isFetching } = useInventory({ keepUnusedDataFor: 0 });

  if (isFetching) {
    return <LoadingText />;
  }

  return (
    <>
      <ScanAndFilter />
      <Inventory />
      <Bottom />
    </>
  );
};

export default ConsignmentStockMain;
